<script>
import formdate from "@/router/views/FormComponet/formdate.vue";
import forminput from "@/router/views/FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import ODuyuru from "@/models/ODuyuru";
import moment from "moment";
export default {
  mixins: [Api, Sabit, ODuyuru],
  props: ["Id", "AddEdit","UygulamaId"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
    formcheckbox,
    formdate,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
   
    },


      

  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        this.FormData.UygulamaId = this.UygulamaId;

        if (this.AddEdit == "Add") {
          this.Post("ODuyuru", this.FormData).then((res) => {
            if (res) {
                this.FormData = this.ODuyuruData
                this.$emit("TableUpdate");
                this.$bvModal.hide("ODuyuru");
            }
          });
        } else {
          this.Update("ODuyuru", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.ODuyuruData
              this.$emit("TableUpdate");
              this.$bvModal.hide("ODuyuru");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="ODuyuru"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('ODuyuru.AddEdit.FormTitleEdit')
          : $t('ODuyuru.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
   
      <Form @submit.prevent="onSubmit">  
 
        <forminput
          :FormDataType="FormDataType.Baslik"
          :Value="FormData.Baslik"
          :v="$v.FormData.Baslik"
          @input="FormData.Baslik = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Icerik"
          :Value="FormData.Icerik"
          :v="$v.FormData.Icerik"
          @input="FormData.Icerik = $event"
        />
        <formdate
          :FormDataType="FormDataType.IslemTarihi"
          :Value="FormData.IslemTarihi"
          :v="$v.FormData.IslemTarihi"
          @input="FormData.IslemTarihi = $event"
        />
        <formcheckbox
          :FormDataType="FormDataType.YeniMi"
          :Value="FormData.YeniMi"
          :v="$v.FormData.YeniMi"
          @input="FormData.YeniMi = $event"
        />

        <button class="btn btn-primary" type="submit">
          {{ $t("ODuyuru.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
